module.exports = __webpack_public_path__ + "img/img2_7.6f955cc9.jpeg";